var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{attrs:{"text":_vm.sortBy,"variant":"outline"}},_vm._l((_vm.sortOptions),function(opt,index){return _c('b-dropdown-item',{key:index,attrs:{"href":"#"},on:{"click":() => {
        _vm.sortBy = opt;
        _vm.sort(opt);
      }}},[_vm._v(_vm._s(opt))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }